// extracted by mini-css-extract-plugin
module.exports = {"btn":"MassActions_btn__3t7bP"};